export default {
    data() {
        return {
            tableGBoptions: {
                modals: [{
                        modal: "Descargar",
                        icon: "download",
                        title: "Descargar Registro",
                        showFtn: function(value) {
                            if (value['info_ingresos/anulado'] === 0 && value['autorizar'].length === 0) { return true }
                            return false;
                        },
                        movil: true
                    },
                    {
                        modal: "Anular",
                        icon: "x-circle",
                        title: "Anular Registro",
                        variant: 'danger',
                        showFtn: function(value) {
                            if ((value['info_ingresos/anulado'] === 0 && value['info_afiliacion/id_list_novedad'] === 1 && value['autorizar'].length === 0) || (value['info_ingresos/anulado'] === 0 && value['info_ingresos/servicios'] === 2 && value['autorizar'].length === 0)) { return true }
                            return false;
                        },
                        movil: true
                    },
                ]
            },

            tableGBSearch: ['info_ingresos/documento', 'info_ingresos/name', 'datos_asesor/name'],

            tableGBItems: [{
                    thead: { th: 'Documento', sort: null, sortTable: 'info_ingresos/documento' },
                    tbody: { td: ['info_ingresos/documento', ] }
                },
                {
                    thead: { th: 'Nombre', sort: null, sortTable: 'info_ingresos/name' },
                    tbody: { td: ['info_ingresos/name'], }
                },
                {
                    thead: { th: 'Razón', },
                    tbody: { td: ['datos_razon/name'], }
                },
                {
                    thead: { th: 'Asesor', },
                    tbody: { td: ['datos_asesor/name'], ftn: function(value) { let name = value.split(' '); if (name.length > 1) { return name[0] + ' ' + name[1] } else { return name[0] } } }
                },
                {
                    thead: { th: 'Registro', },
                    tbody: { td: ['info_ingresos/id'], link: '/api/pdf/registro', show: { td: 'info_ingresos/anulado', compare: 0, else: 'Anulado' } }
                },
                {
                    thead: { th: 'Valor', },
                    tbody: { td: ['info_ingresos/valor'] }
                },
                {
                    thead: { th: 'Radicador', },
                    tbody: { td: ['list_users/name'], ftn: function(value) { return value.split(' ')[0] } }
                },
            ],

        }
    },
}